import { BaseMapper } from '@/core/mapper';

import { Vendor } from '@/core/vendor';
import { Location } from '@/core/location';

const schema = {
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  title: {
    parseFrom: 'attributes.title',
  },
  client: {
    fromResponse: (entity) => {
      const client = _.get(entity, 'relationships.client');
      return client && new Vendor(client);
    },
    omitFromRequest: true,
  },
  location: {
    fromResponse: (entity) => {
      const location = _.get(entity, 'relationships.location');
      return location && new Location(location);
    },
    omitFromRequest: true,
  },
  one_time_pass_compliance_requirements: {
    // TODO: Map properly when the time comes to use this
    parseFrom: 'relationships.one_time_pass_compliance_requirements',
    omitFromRequest: true,
  },
};

class OneTimePass extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

OneTimePass.schema = schema;

export default OneTimePass;
